<template>
    <div>
         <div class="page-title">Add  New Template</div>
         <div class="page-box">
            <templateFrom ref="ruleForm" :form="form"></templateFrom>
            <div class="page-btn">
                <el-button type="warning" @click="onSubmit">Submit</el-button>
                <el-button @click="onBack">Cancel</el-button>
            </div>
         </div>
    </div>
</template>

<script>
    import {addTemplates} from '@/api/admin/notification'
    import templateFrom from './components/templateFrom'
    export default {
        components:{templateFrom},
        props:{
          formType:{
            type:Number,
            default:0
          }
        },
        data() {
            return {
                form: {
                    type: 0, 
                    statusTemplateType: 0, 
                    formType: this.formType, 
                    title: null, 
                    email: {
                        subject: null, 
                        body: null
                    }, 
                    announcement: {
                        subject: null, 
                        body: null
                    }
                }
            }
        },
        methods:{
            onSubmit(){
                this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.addTemplates()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                
            },
            addTemplates(){
                addTemplates(this.form).then(()=>{
                     this.$message({
                        message: 'Added Successfully',
                        type: 'success'
                    });
                    this.onBack()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding: 20px;
}
.page-btn{
    text-align: right;
}
</style>